import { NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteWithSteps, StepConfiguration } from './step-configuration.model';

@Component({
  selector: 'ez-stepper',
  imports: [NgTemplateOutlet],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss',
})
export class StepperComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  public stepsConfigs: StepConfiguration[];
  public currentStepConfig: StepConfiguration | undefined;

  constructor() {
    this.currentStepConfig = (this.route.snapshot as RouteWithSteps).data?.stepConfig;
    this.stepsConfigs = this.router.config
      .filter((route) => route.data && route.data['stepConfig'])
      .map((route) => route.data!['stepConfig'] as StepConfiguration)
      .sort((a, b) => a.step - b.step);
  }
}
